<template>

	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-8 col-md-10 col-sm-12 mx-auto user-panel mt-5 mb-5">

				<div class="alert alert-success" v-if="oauthReturnSuccess == true">
					We have succssfully linked your Live Storm Chasing account to your Live Storms Media account.
				</div>

				<div class="alert pt-3 pb-3 mx-auto mt-5" style="max-width: 600px;" v-if="credentials['access_token'] == undefined">
					<h3>Action Required</h3> <br/>
					<p>
						You must link your <a href="https://portal.livestormchasing.com" target="_blank">Live Storm Chasing</a> account to your Live Storms Media account to continue.
						If you don't already have a <a href="https://portal.livestormchasing.com" target="_blank">Live Storm Chasing</a> account, you can get one <a href="https://portal.livestormchasing.com" target="_blank">here</a> and then follow the steps below. </br></br>

						<strong>If you have been able to stream since early 2017, you already have an account. Please follow the steps below.</strong>
					</p>

					<h4 class="mt-5">Steps to link your account:</h4>
					<ul>
						<li>Reset your password on your Live Storm Chasing account. You can do that <a href="https://portal.livestormchasing.com/reset" target="_blank">here</a>.</li>
						<li>Click "Connect Live Storm Chasing Account" below.</li>
						<li>Login with your <strong>Live Storm Chasing</strong> account details.</li>
						<li>At the <strong>AUTHORIZATION REQUEST</strong> prompt, click <strong>Authorize</strong>.</li>
					</ul>

					<button class="btn btn-primary mt-4" style="color: #fff; margin: 0 auto;" v-on:click="connectLscAccount()">Connect Live Storm Chasing Account</button>
				</div>

				<div class="col-md-12">

				</div>

			</div>
		</div>
	</div>

</template>

<script>

	import { EventBus } from '@/utils/events';
	import * as Config from '@/config'
	import { mapState, mapGetters } from 'vuex';

	export default {
		name: 'LSC',
		data () {
			return {
				oauthReturnSuccess: null,
				credentials: [],
				lscData: [],
			}
		},
		mounted() {
            if(this.$route.query.status !== undefined && this.$route.query.status == "linked") {
				this.oauthReturnSuccess = true;
            }
			this.getLscCreds()
        },
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
            ]),
			connectLscAccount() {
				window.location.replace('https://lsc-api.app/oauth/authorize?client_id=3&redirect_uri=http://localhost:8081/stringer/lsc/callback&response_type=code&scope=');
			},
			getLscCreds() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/stringer/lsc", this.getAuthorizationHeader()).then((response) => {
                    _this.credentials = response.data
					if(response.data.access_token !== undefined) {
						_this.getLscOverview();
					}
                });
            },
			getLscOverview() {
				this.$http.get(Config.apiPath + "/api/v2/stringer/lsc", this.getAuthorizationHeader()).then((response) => {
                    _this.credentials = response.data
					if(response.data.access_token !== undefined) {
						_this.getLscOverview();
					}
                });
			}
		}
	}
</script>

<style scoped>

</style>
